import React from 'react';
export function CrossfitPro() {
  return <section className="py-12 md:py-20 px-4 bg-cf-darker" data-id="element-172">
      <div className="max-w-5xl mx-auto" data-id="element-173">
        <h2 className="font-bebas text-3xl md:text-6xl text-center text-white tracking-tight mb-8 md:mb-12" data-id="element-174">
          CROSSFIT PRO™ INCLUYE:
        </h2>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-175">
          {/* Upsell 1 */}
          <div className="bg-cf-card border border-cf-gold/30 rounded-xl p-5 md:p-8 relative" data-id="element-176">
            <div className="absolute -top-4 left-5 md:left-8 bg-cf-darker border border-cf-gold text-cf-gold px-3 py-1 rounded text-xs md:text-sm font-bold tracking-wider" data-id="element-177">
              💎 UPSELL 1
            </div>
            <h3 className="font-bebas text-2xl md:text-3xl text-white mb-2 mt-4" data-id="element-178">
              "Prevención de Lesiones en Crossfit"
            </h3>
            <p className="text-gray-400 text-xs md:text-sm mb-5 md:mb-6" data-id="element-179">
              (60 páginas)
            </p>

            <ul className="space-y-3 md:space-y-4 text-sm md:text-base" data-id="element-180">
              {['Las lesiones más frecuentes del box y cómo prevenirlas antes de que ocurran', 'Protocolo de primeros auxilios para el instructor: PRICE paso a paso', 'Señales de alarma que requieren derivación inmediata al médico', 'Programa preventivo semanal de 8 semanas por zona corporal: hombro, lumbar, rodilla y tobillo', 'Cómo gestionar la carga para que tus alumnos nunca se sobreentrenan', 'Protocolo de retorno al entrenamiento post-lesión', 'Cómo comunicarte con el kinesiólogo del alumno de forma profesional', 'Ficha de registro de lesiones lista para el box'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-181">
                  <span className="text-cf-gold mt-1" data-id="element-182">•</span>
                  <span data-id="element-183">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Upsell 2 */}
          <div className="bg-cf-card border border-cf-gold/30 rounded-xl p-5 md:p-8 relative" data-id="element-184">
            <div className="absolute -top-4 left-5 md:left-8 bg-cf-darker border border-cf-gold text-cf-gold px-3 py-1 rounded text-xs md:text-sm font-bold tracking-wider" data-id="element-185">
              💎 UPSELL 2
            </div>
            <h3 className="font-bebas text-2xl md:text-3xl text-white mb-2 mt-4" data-id="element-186">
              "Crossfit para Patologías"
            </h3>
            <p className="text-gray-400 text-xs md:text-sm mb-5 md:mb-6" data-id="element-187">
              (60 páginas)
            </p>

            <ul className="space-y-3 md:space-y-4 text-sm md:text-base" data-id="element-188">
              {['Cómo adaptar el entrenamiento para alumnos con hipertensión, diabetes, obesidad, osteoporosis, artrosis y cardiopatías', 'Protocolos específicos por patología: qué sí, qué no y qué monitorear en cada clase', 'Tabla de medicaciones que afectan el rendimiento: beta bloqueantes, insulina, diuréticos y más', 'Clase completa adaptada lista para cada condición', 'Consentimiento informado ampliado para alumnos con patologías', 'Protocolo de emergencia por patología: hipoglucemia, crisis hipertensiva, crisis asmática', 'Cómo comunicarte con el médico tratante del alumno de forma profesional', 'No perder ningún alumno por su diagnóstico'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-189">
                  <span className="text-cf-gold mt-1" data-id="element-190">•</span>
                  <span data-id="element-191">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}